var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("bjtkxx"),
        visible: _vm.show,
        width: "70%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-row",
            [
              _vm.pageType == "yhk"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("khxm"),
                            prop: "bank_user_name",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrkhxm") },
                            model: {
                              value: _vm.formValidate.bank_user_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "bank_user_name",
                                  $$v
                                )
                              },
                              expression: "formValidate.bank_user_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType == "yhk"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("ssyh"), prop: "bank_name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrssyh") },
                            model: {
                              value: _vm.formValidate.bank_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "bank_name", $$v)
                              },
                              expression: "formValidate.bank_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType == "yhk"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("zhmc"),
                            prop: "bank_branch_name",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrzhmc") },
                            model: {
                              value: _vm.formValidate.bank_branch_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "bank_branch_name",
                                  $$v
                                )
                              },
                              expression: "formValidate.bank_branch_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType == "yhk"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("yhkh"),
                            prop: "bank_account",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsryhkh") },
                            model: {
                              value: _vm.formValidate.bank_account,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "bank_account", $$v)
                              },
                              expression: "formValidate.bank_account",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType == "qb"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("qbmc"), prop: "wallet_name" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrqbmc") },
                            model: {
                              value: _vm.formValidate.wallet_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "wallet_name", $$v)
                              },
                              expression: "formValidate.wallet_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType == "qb"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("qbdz"),
                            prop: "wallet_address",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrqbdz") },
                            model: {
                              value: _vm.formValidate.wallet_address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "wallet_address",
                                  $$v
                                )
                              },
                              expression: "formValidate.wallet_address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }